import MvBody from './MvBody/MvBody';
import MvHeader from './MvHeader/MvHeader';

function Mv() {
    return (
        <>
            <MvHeader />
            <MvBody />
        </>
    );
}

export default Mv;
